import { fetchFileAsBlob } from '~/utils/fetchFileAsBlob';

export const openFileInNewTab = async ({ mimeType, route }: { route: string; mimeType?: string }) => {
    let blobUrl: string | null = null;

    try {
        blobUrl = (await fetchFileAsBlob({ mimeType, route })).blobUrl;

        // Open in new tab
        const newWindow = window.open(blobUrl, '_blank', 'noopener,noreferrer');
        if (newWindow) {
            newWindow.opener = null;
            // Clean up the blob URL after the window is closed or after a delay
            newWindow.addEventListener('beforeunload', () => {
                if (blobUrl) {
                    URL.revokeObjectURL(blobUrl);
                }
            });
            // Fallback cleanup after 5 minutes
            setTimeout(() => {
                if (blobUrl) {
                    URL.revokeObjectURL(blobUrl);
                }
            }, 5 * 60 * 1000);
        }
    } catch (error) {
        // Clean up blob URL on error
        if (blobUrl) {
            URL.revokeObjectURL(blobUrl);
        }
        throw error;
    }
};
